/**
 * @description
 */
import * as postSoletrader from './postSoletrader';
import * as putSoletraderById from './putSoletraderById';

export { postSoletrader, putSoletraderById };
